// Converts the current viewport width to the breakpoint names used by Vue views.
export default function getWindowSize(width = document.documentElement.clientWidth) {
    if (width < 576) return 'xs';
    if (width < 768) return 'sm';
    if (width < 992) return 'md';
    if (width < 1200) return 'lg';
    return 'xl';
}
